import Base64 from "Base64";
import jwtDecode from "jwt-decode";

import validate from "../core/validate";
import request from "../core/request";
import safeCall from "../core/safeCall";
import { setToken } from "../config";

/**
 * Execute the user login
 *
 * @param {Object} payload - The object with all the params
 * @param {string} payload.email - the email to authenticate
 * @param {string} payload.password - the password
 * @param {string} payload.distributor - the password
 * @param {string} payload.company - the password
 * @param {string} payload.role - the user role
 * @param {Object} payload.deviceInfo - the device properties
 * @param {string} payload.deviceInfo.browser - The name of the browser.
 * @param {string} payload.deviceInfo.os - The operational system name.
 * @param {string} payload.deviceInfo.internetSpeed - The internet speed.
 * @param {string} payload.deviceInfo.screenSize - The screen size (width_height).
 *
 * @throws {ApiError} throws an exception with the api error
 *
 * @returns {Promise<{id: *, accessToken: *}>}
 */
export const login = async (payload) => {
  validate(
    {
      email: {
        presence: {
          allowEmpty: false,
        },
      },
      password: {
        presence: {
          allowEmpty: false,
        },
      },
      role: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    payload
  );

  if (payload.role === "STUDENT") {
    validate(
      {
        deviceInfo: {
          presence: {
            allowEmpty: false,
          },
        },
        "deviceInfo.browser": {
          presence: {
            allowEmpty: false,
          },
        },
        "deviceInfo.os": {
          presence: {
            allowEmpty: false,
          },
        },
        "deviceInfo.internetSpeed": {
          presence: {
            allowEmpty: false,
          },
        },
        "deviceInfo.screenSize": {
          presence: {
            allowEmpty: false,
          },
        },
      },
      payload
    );
  }

  return safeCall(
    async () => {
      const loginResult = await request({
        url: "auth/certification-test",
        method: "post",
        headers: {
          Authorization: `Basic ${Base64.btoa(`${payload.email}:${payload.password}`)}`,
        },
        data: {
          distributor: payload.distributor,
          company: payload.company,
          ...payload.deviceInfo,
        },
      });

      const decodeResult = jwtDecode(loginResult.accessToken);
      setToken(loginResult.accessToken);

      return {
        id: decodeResult.sub,
        accessToken: loginResult.accessToken,
        locale: decodeResult.locale,
        timezone: decodeResult.timezone,
        academicPlan: decodeResult.academicPlan,
      };
    },
    "login_error",
    "Unexpected error on authentication."
  );
};
